// Mobile menu
const menuOpen = document.querySelector('[data-menu-open]');
const menuClose = document.querySelector('[data-menu-close]');
const mobileMenu = document.querySelector('[data-mobile-menu]');

if (menuOpen && mobileMenu) {
  menuOpen.addEventListener('click', () => {
    mobileMenu.hidden = false;
    document.body.style.overflow = 'hidden';
    const first = mobileMenu.querySelector('button, a');
    if (first) first.focus();
  });
}
if (menuClose && mobileMenu) {
  menuClose.addEventListener('click', () => {
    mobileMenu.hidden = true;
    document.body.style.overflow = '';
    if (menuOpen) menuOpen.focus();
  });
}
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape' && mobileMenu && !mobileMenu.hidden) {
    mobileMenu.hidden = true;
    document.body.style.overflow = '';
    if (menuOpen) menuOpen.focus();
  }
});

// Language selector
document.querySelectorAll('[data-language-toggle]').forEach(toggle => {
  const list = toggle.parentElement.querySelector('[data-language-list]');
  toggle.addEventListener('click', () => {
    const expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!expanded));
    if (list) list.hidden = expanded;
  });
});

// Close language list on outside click
document.addEventListener('click', (e) => {
  document.querySelectorAll('[data-language-form]').forEach(form => {
    if (!form.contains(e.target)) {
      const toggle = form.querySelector('[data-language-toggle]');
      const list = form.querySelector('[data-language-list]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      if (list) list.hidden = true;
    }
  });
});
